import React from 'react'
import styles from './CardTable.module.scss'
import { CardTableCell } from './CardTableCell'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import { Button } from 'components/shared/Button/Button'
import { Trash2Icon } from 'components/shared/Icon/Icon'
import { CHECKBOX_CELL_WIDTH, CLOSE_CELL_WIDTH } from './constants'
import cx from 'classnames'

type CardTableRowProps = {
  children?: React.ReactNode
  withCheckbox?: boolean
  withRemove?: boolean
  onClick?: React.MouseEventHandler<HTMLTableRowElement>
  toggleRowSelection?: (id: CardTableRowProps['id']) => void
  selected?: boolean
  deleteRow?: (id: CardTableRowProps['id']) => void
  className?: string
  id?: string | number
}

export const CardTableRow = ({
  children,
  withCheckbox,
  withRemove,
  onClick,
  toggleRowSelection,
  selected = false,
  deleteRow,
  className,
  id,
}: CardTableRowProps) => {
  const ref = React.useRef(null)

  return (
    <tr
      className={cx(styles.cardTableRowContainer, className)}
      onClick={onClick}
    >
      {children}
      {withCheckbox ? (
        <CardTableCell
          width={CHECKBOX_CELL_WIDTH}
          className={styles.justifyRight}
        >
          <Checkbox
            value={selected}
            onChange={e => {
              e.stopPropagation()
              toggleRowSelection?.(id)
            }}
            ref={ref}
          />
        </CardTableCell>
      ) : null}
      {withRemove ? (
        <CardTableCell width={CLOSE_CELL_WIDTH} className={styles.justifyRight}>
          <Button
            ariaLabel="close"
            className={styles.closeButton}
            icon={Trash2Icon}
            size="small"
            variant="text"
            onClick={e => {
              e.stopPropagation()
              deleteRow?.(id)
            }}
          />
        </CardTableCell>
      ) : null}
    </tr>
  )
}
